import {useState} from 'react'
import {InputRadio} from '@/components/ui/input-radio/InputRadio'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {
    StyledBulkSiarExportOtherBatchBanner,
    StyledBulkSiarExportOtherBatchRadioGroup,
    StyledBulkSiarExportOtherBatchRadioLabel
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

type OtherBatchSelection = 'include' | 'ignore'

type BulkSiarExportInOtherBatchBannerProps = {
    count: number
    onInclude: () => void
    onIgnore: () => void
}

export const BulkSiarExportInOtherBatchBanner = ({
    count,
    onInclude,
    onIgnore
}: BulkSiarExportInOtherBatchBannerProps) => {
    const {t} = useTranslation()
    const [selection, setSelection] = useState<OtherBatchSelection>('include')

    const handleChange = (value: OtherBatchSelection) => {
        if (value === selection) return
        setSelection(value)
        if (value === 'include') onInclude()
        else onIgnore()
    }

    return (
        <StyledBulkSiarExportOtherBatchBanner>
            <Flexbox align="center" gap={2}>
                <AlertCircleIcon size={16} />
                <strong>{t('projects:bulk_siar_export_other_batch_banner', {count})}</strong>
            </Flexbox>
            <p>{t('projects:bulk_siar_export_other_batch_banner_description', {count})}</p>
            <StyledBulkSiarExportOtherBatchRadioGroup>
                <StyledBulkSiarExportOtherBatchRadioLabel>
                    <InputRadio
                        name="other-batch-selection"
                        value="include"
                        checked={selection === 'include'}
                        onChange={() => handleChange('include')}
                    />
                    {t('projects:bulk_siar_export_include_and_move', {count})}
                </StyledBulkSiarExportOtherBatchRadioLabel>
                <StyledBulkSiarExportOtherBatchRadioLabel>
                    <InputRadio
                        name="other-batch-selection"
                        value="ignore"
                        checked={selection === 'ignore'}
                        onChange={() => handleChange('ignore')}
                    />
                    {t('projects:bulk_siar_export_ignore_and_proceed')}
                </StyledBulkSiarExportOtherBatchRadioLabel>
            </StyledBulkSiarExportOtherBatchRadioGroup>
        </StyledBulkSiarExportOtherBatchBanner>
    )
}
